import StateMenu, { type StateMenuProps } from '@components/stateMenu';
import { Button } from '@components/ui/button';
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogTrigger
} from '@components/ui/dialog';
import useStore from '@hooks/useStore';
import type { AtomReference } from '@stratumn/studio-shared';
import { Pencil, X } from 'lucide-react';
import { useState } from 'react';

type Props = StateMenuProps & {
  selectedRef?: AtomReference | null;
  editable?: boolean;
  /** @deprecated Use `selectedRef` props instead! */
  value?: string;
  placeholder?: string;
  disabled?: boolean;
};

export const VariableSelector = ({
  value,
  selectedRef,
  placeholder = 'Select a variable',
  disabled = false,
  editable = true,
  onSelected,
  specificSourceIds,
  specificResolvedTypes
}: Props) => {
  const { atomStore } = useStore();
  const [isStateMenuOpen, setStateMenuOpen] = useState<boolean>(false);

  const name =
    atomStore.getAtomReferenceTitle(selectedRef) ?? value ?? placeholder;

  const onRemoveSelectedRef = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    if (!selectedRef) {
      return;
    }
    e.stopPropagation();
    if (!onSelected) {
      return;
    }
    onSelected(undefined);
  };
  return (
    <Dialog
      onOpenChange={open => setStateMenuOpen(open)}
      open={isStateMenuOpen}
    >
      <DialogTrigger disabled={disabled}>
        <Button
          className="hover:bg flex h-8 w-[220px] items-center justify-between gap-2 overflow-hidden rounded-md border border-input border-solid bg-background py-2 pr-1 pl-3 font-normal text-sm ring-offset-background hover:bg-accent hover:text-accent-foreground"
          data-tag="variable-field"
          disabled={disabled}
          onClick={e => {
            e.preventDefault();
            if (!onSelected || disabled) {
              return;
            }
            setStateMenuOpen(true); // ! bad
          }}
          variant="outline"
        >
          <p className="overflow-hidden overflow-ellipsis whitespace-nowrap">
            {name}
          </p>
          {editable &&
            (selectedRef ? (
              <div
                className="flex h-6 w-6 shrink-0 items-center justify-center rounded hover:bg-gray-300"
                onClick={onRemoveSelectedRef}
              >
                <X className="h-4 w-4 shrink-0 opacity-50" />
              </div>
            ) : (
              <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded hover:bg-gray-300">
                <Pencil className="h-4 w-4 shrink-0 opacity-50" />
              </div>
            ))}
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogBody className="m-0 p-0">
          <StateMenu
            onClose={() => setStateMenuOpen(false)}
            onSelected={onSelected ?? (() => {})}
            specificResolvedTypes={specificResolvedTypes}
            specificSourceIds={specificSourceIds}
          />
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
};
